import { useMutation } from '@tanstack/react-query'
import { createIntegrationToken } from '@/features/internal/patient-messaging/apis/patientMessagingApi'
import { IntegrationToken } from '@/features/internal/patient-messaging/types/patientMessaging'

export const useCreateTokenMutation = () => {
  return useMutation({
    mutationFn: async (patientId: string): Promise<IntegrationToken> => {
      return await createIntegrationToken(patientId)
    },
  })
}
